import Notification from '../domain/entities/Notification/Notification';
import { GENERAL } from '../constants/Errors';
import { IApiError, IApiErrorElement } from '../api';
import { NOTIFICATION_GROUP } from '../constants/Notifications';
import NotificationError from '../application/NotificationError';

const normalizeErrorElements = (errors: IApiErrorElement[], notificationGroup?: NOTIFICATION_GROUP): Notification[] => errors.map(
  (error: IApiErrorElement) => (Notification.fromJSON({
    data: error.data,
    group: notificationGroup,
    key: error.key,
  })),
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isApiError = (candidate: any): candidate is IApiError => (
  candidate && candidate.errorResponse
);

const normalizeApiErrors = (error: IApiError | TypeError, notificationGroup?: NOTIFICATION_GROUP): Notification[] => {
  let normalizedErrors: Notification[] = [Notification.fromJSON({
    data: {},
    error: (error as TypeError),
    group: notificationGroup,
    key: GENERAL.GENERIC,
  })];

  if (error instanceof NotificationError) {
    normalizedErrors = [Notification.fromJSON(error.notification)];
  }

  if (isApiError(error)) {
    const { errors } = error.errorResponse.data;
    normalizedErrors = normalizeErrorElements(errors, notificationGroup);
  }

  return normalizedErrors;
};

export default normalizeApiErrors;

export {
  normalizeErrorElements,
};
